<template>
  <div class="table table-bg">
    <div class="table-header center">
      <div class="table-tlt center-left">
        <h2>회사 리스트</h2>
      </div>
      <div class="table-btn center-right">
        <div class="btn-frige-register" @click="createCompany">
          <button class="btn btn-140"><span><img src="/static/img/ico-plus-white@2x.png" alt=""></span>회사 등록</button>
        </div>
        <div class="btn-renew" @click="refreshList">
          <button class="btn btn-40"><span><img src="/static/img/ico-renew@2x.png" alt=""></span></button>
        </div>
        <!-- <div class="btn-export-excel" @click="downloadExcel">
          <button class="btn btn-40"><span><img src="/static/img/ico_excel@2x.png" alt=""></span></button>
        </div> -->
      </div>
    </div>
    <div class="table-desc">
      <table>
        <tr class="header">
          <th>회사 ID</th>
          <th>회사 이름</th>
          <th>사업자 번호</th>
          <th>역할</th>
          <th>모회사 ID</th>
          <th>모회사 이름</th>
          <th>모회사 역할</th>
        </tr>

        <tbody v-if="loading === false && pagination.total > 0">
          <tr v-for="item in companyList" :key="item.companyID" @click="goDetail(item)">
            <td>
              <!-- TODO <div>{{ item.companyAlias }}</div> -->
              <div>{{ item.companyID }}</div>
            </td>
            <td>
              <div>{{ item.companyName }}</div>
            </td>
            <td>
              <div>{{ item.registrationNo }}</div>
            </td>
            <td>
              <div>{{ $getConstName('companyScope', item.scope) }}</div>
            </td>
             <td>
              <!-- TODO <div>{{ item.parentCompanyAlias ? item.parentCompanyAlias : '-' }}</div> -->
              <div>{{ item.parentCompanyID ? item.parentCompanyID : '-' }}</div>
            </td>
            <td>
              <div>{{ item.parentCompanyName ? item.parentCompanyName : '-' }}</div>
            </td>
            <td>
              <div>{{ item.parentCompanyScope ? $getConstName('companyScope', item.parentCompanyScope) : '-' }}</div>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="4">등록된 회사가 없습니다.</td>
          </tr>
        </tbody>
      </table>

      <div class="pagination" v-if="pagination.total > 0">
        <span class="pagination-prev" @click="goPrev">
          <img src="/static/img/ico-arrow-line.png" alt />
        </span>

        <span v-if="pagination.pageArray[0] > 1" @click="goPage(1)">1</span>
        <span v-if="pagination.pageArray[0] > 1" @click="jumpPrev">...</span>
        <span
          v-for="n in pagination.pageArray"
          :key="n"
          :class="n === pagination.page ? 'page-num current' : 'page-num'"
          @click="goPage(n)"
          >{{ n }}
        </span>
        <span
          v-if="
            pagination.pageArray[pagination.pageArray.length - 1] <
            pagination.length
          "
          @click="jumpNext"
          >...
        </span>
        <span
          v-if="
            pagination.pageArray[pagination.pageArray.length - 1] <
            pagination.length
          "
          @click="goPage(pagination.length)"
          >{{ pagination.length }}
        </span>

        <span class="pagination-next" @click="goNext">
          <img src="/static/img/ico-arrow-line.png" alt />
        </span>

        <input
          type="number"
          v-model="pagination.input"
          @keyup.enter="goPage(Number(pagination.input))"
        />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-alert */
/* eslint-disable no-console */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */

import Configuration from '@/js/Configuration';

export default {
  props: [
    'searchCondition',
    'searchEvent',
    'startTime',
    'endTime',
  ],
  data: () => ({
    companyList: [],
    sum: null,
    pagination: {
      page: 1,
      total: 0,
      length: 1,
      perPage: 10,
      perLength: 5,
      pageArray: [],
      input: 1,
    },
    loading: true,
    role: 0,
    scope: 0,
    companyID: '',
  }),
  created() {
    const token = this.$jwtDecode(this.$cookie.get('accessToken'));
    this.role = token.role;
    this.scope = token.scope;
    this.companyID = token.companyID;

    this.loadPagination();
    this.getCompanyList();
  },
  watch: {
    searchEvent() {
      this.pagination.page = 1;
      this.pagination.input = 1;
      this.pagination.total = 0;
      this.pagination.length = 1;

      this.getCompanyList();
    },
  },
  methods: {
    refreshList() {
      this.getCompanyList();
    },
    savePagination() {
      const page = {
        company: this.pagination.page,
      };
      sessionStorage.setItem('pagination', JSON.stringify(page));
    },
    loadPagination() {
      const page = JSON.parse(sessionStorage.getItem('pagination'));
      if (page !== null && page.company !== undefined) this.pagination.page = page.company;
    },
    async getCompanyList() {
      this.savePagination();
      this.companyList = [];
      this.pagination.input = this.pagination.page;
      this.loading = true;

      try {
        let countURL = `${Configuration.value(
          'CACCOUNT_ADDRESS',
        )}/api/v1/caccount/company/count`;
        countURL += `?role=${this.role}&scope=${this.scope}&companyID=${this.companyID}`;
        if (this.searchCondition) {
          countURL += `&${this.searchCondition}`;
        }
        const count = await this.$http.get(countURL, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
          },
        });
        if (count.status !== 200) {
          throw new Error(`Response status is "${count.status}"`);
        }
        if (count.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${count.data.resultCode}"`);
        }
        if (count.data.count < 1) {
          this.pagination.page = 1;
          this.pagination.total = 0;
          this.pagination.length = 1;
          this.loading = false;
          return;
        }

        this.pagination.total = count.data.count;
        this.pagination.length = Math.ceil(
          this.pagination.total / this.pagination.perPage,
        );

        const pageBack = Math.floor((this.pagination.perLength - 1) / 2);
        const pageForward = this.pagination.perLength - 1 - pageBack;
        let firstPage = this.pagination.page - pageForward;
        let lastPage = this.pagination.page + pageBack;
        if (firstPage < 1) {
          firstPage = 1;
          lastPage = this.pagination.perLength;
        }
        if (lastPage > this.pagination.length) {
          lastPage = this.pagination.length;
        }
        if (lastPage - firstPage + 1 < this.pagination.perLength) {
          if (firstPage > 1) {
            firstPage -= this.pagination.perLength - lastPage + firstPage - 1;
            if (firstPage < 1) {
              firstPage = 1;
            }
          } else if (lastPage < this.pagination.length) {
            lastPage += this.pagination.perLength - lastPage + firstPage - 1;
            if (lastPage > this.pagination.length) {
              lastPage = this.pagination.length;
            }
          }
        }

        this.pagination.pageArray = [];
        for (let i = firstPage; i <= lastPage; i++) {
          this.pagination.pageArray.push(i);
        }

        let num =
          this.pagination.total -
          (this.pagination.page - 1) * this.pagination.perPage;
        const companyList = [];

        let listURL = `${Configuration.value(
          'CACCOUNT_ADDRESS',
        )}/api/v1/caccount/company/list?page=${this.pagination.page}&limit=${
          this.pagination.perPage
        }`;
        listURL += `&role=${this.role}&scope=${this.scope}&companyID=${this.companyID}`;
        if (this.searchCondition) {
          listURL += `&${this.searchCondition}`;
        }
        const list = await this.$http.get(listURL, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
          },
        });
        if (list.status !== 200) {
          if (list.status === 204) {
            this.pagination.page = 1;
            this.pagination.total = 0;
            this.pagination.length = 1;
            this.loading = false;
            return;
          }

          throw new Error(`response status is "${list.status}"`);
        }
        if (list.data.resultCode !== '0000') {
          throw new Error(`resultcode is "${list.data.resultCode}"`);
        }

        await this.fetchCompanyList(list.data.companies);
        await this.fetchUserList(list.data.companies);

        for (let i = 0; i < list.data.companies.length; i++) {
          const p = list.data.companies[i];

          p.num = num;
          companyList.push(p);

          num--;
        }

        this.companyList = companyList;
        this.loading = false;
      } catch (e) {
        this.pagination.page = 1;
        this.pagination.total = 0;
        this.pagination.length = 1;
        this.companyList = [];
        this.loading = false;
        console.error(e);
      }
    },
    async fetchCompanyList(list) {
      const companyList = [];
      for (let i = 0; i < list.length; i++) {
        const ba = this.getCompanyData(list[i]);
        companyList.push(ba);
      }

      return Promise.all(companyList);
    },
    async getCompanyData(value) {
      try {
        if (value.parentCompanyID) {
          const response = await this.$http.get(
            `${Configuration.value('CACCOUNT_ADDRESS')}/api/v1/caccount/company/${value.parentCompanyID}?withDivisions=false`,
            {
              headers: {
                Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
              },
            },
          );
          if (response.data.resultCode === '0000') {
            value.parentCompanyName = response.data.company.companyName;
            value.parentCompanyAlias = response.data.company.companyAlias;
            value.parentCompanyScope = response.data.company.scope;
          }
        }
      } catch (e) {
        console.error(e);
      }
    },
    async fetchUserList(list) {
      const userList = [];
      for (let i = 0; i < list.length; i++) {
        const ba = this.getUserData(list[i]);
        userList.push(ba);
      }

      return Promise.all(userList);
    },
    async getUserData(value) {
      try {
        if (value.representativeUID) {
          const response = await this.$http.get(
            `${Configuration.value('CACCOUNT_ADDRESS')}/api/v1/caccount/user/${value.representativeUID}`,
            {
              headers: {
                Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
              },
            },
          );
          if (response.data.resultCode === '0000') {
            value.representativeUserID = response.data.user.userID;
            value.representativeName = response.data.user.name;
            value.representativeMobile = response.data.user.mobile;
            value.representativeEmail = response.data.user.email;
          }
        }
      } catch (e) {
        console.error(e);
      }
    },
    goPrev() {
      if (this.pagination.page <= 1) {
        return;
      }
      this.pagination.page--;

      this.getCompanyList();
    },
    goNext() {
      if (this.pagination.page >= this.pagination.length) {
        return;
      }
      this.pagination.page++;

      this.getCompanyList();
    },
    jumpPrev() {
      if (
        Array.isArray(this.pagination.pageArray) &&
        this.pagination.pageArray.length > 0
      ) {
        this.pagination.page = this.pagination.pageArray[0];
        this.pagination.page--;
      } else {
        this.pagination.page = 1;
      }

      if (this.pagination.page < 1) {
        this.pagination.page = 1;
      }

      this.getCompanyList();
    },
    jumpNext() {
      if (
        Array.isArray(this.pagination.pageArray) &&
        this.pagination.pageArray.length > 0
      ) {
        this.pagination.page = this.pagination.pageArray[
          this.pagination.pageArray.length - 1
        ];
        this.pagination.page++;
      } else {
        this.pagination.page = 1;
      }

      if (this.pagination.page > this.pagination.length) {
        this.pagination.page = this.pagination.length;
      }

      this.getCompanyList();
    },
    goPage(page) {
      if (page < 1) {
        page = 1;
      }
      if (page > this.pagination.length) {
        page = this.pagination.length;
      }
      this.pagination.page = page;
      this.getCompanyList();
    },
    goDetail(company) {
      this.$emit('companyDetail', company);
    },
    createCompany() {
      this.$emit('companyCreate');
    },
    downloadExcel() {},
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/account/company/CompanyList.vue